var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup15(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3613 9.29341C22.2064 8.34603 20.8559 7.66635 19.4069 7.30324C17.9579 6.94013 16.4465 6.90262 14.9813 7.19341C13.1951 7.53698 11.5391 8.36892 10.1972 9.59683C8.85534 10.8247 7.88004 12.4006 7.37966 14.1493C6.87928 15.8981 6.8734 17.7513 7.36268 19.5031C7.85195 21.255 8.81723 22.837 10.1513 24.0734C10.4222 24.3446 10.6354 24.6678 10.778 25.0235C10.9207 25.3793 10.9898 25.7602 10.9813 26.1434V28.0034C10.9836 28.4228 11.0737 28.837 11.246 29.2194C11.4182 29.6018 11.6687 29.9438 11.9813 30.2234V32.0034C11.9813 32.7991 12.2974 33.5621 12.86 34.1247C13.4226 34.6873 14.1857 35.0034 14.9813 35.0034H18.9813C19.777 35.0034 20.54 34.6873 21.1026 34.1247C21.6652 33.5621 21.9813 32.7991 21.9813 32.0034V30.2234C22.2939 29.9438 22.5444 29.6018 22.7167 29.2194C22.8889 28.837 22.9791 28.4228 22.9813 28.0034V26.1534C22.9739 25.7656 23.0454 25.3803 23.1915 25.021C23.3376 24.6618 23.5553 24.3359 23.8313 24.0634C24.8633 23.1139 25.6785 21.9531 26.2214 20.6602C26.7644 19.3672 27.0224 17.9724 26.9778 16.5708C26.9332 15.1692 26.587 13.7936 25.963 12.5378C25.3389 11.282 24.4515 10.1754 23.3613 9.29341ZM20.9813 27.0034V28.0034C20.9813 28.2686 20.876 28.523 20.6884 28.7105C20.5009 28.8981 20.2465 29.0034 19.9813 29.0034H13.9813C13.7161 29.0034 13.4617 28.8981 13.2742 28.7105C13.0867 28.523 12.9813 28.2686 12.9813 28.0034V27.0034H20.9813ZM19.9813 32.0034C19.9813 32.2686 19.876 32.523 19.6884 32.7105C19.5009 32.8981 19.2465 33.0034 18.9813 33.0034H14.9813C14.7161 33.0034 14.4617 32.8981 14.2742 32.7105C14.0867 32.523 13.9813 32.2686 13.9813 32.0034V31.0034H19.9813V32.0034ZM22.4513 22.6134C21.7842 23.2632 21.3218 24.094 21.1213 25.0034H12.8413C12.644 24.1001 12.189 23.2733 11.5313 22.6234C10.5519 21.7262 9.81682 20.5946 9.39522 19.3351C8.97362 18.0755 8.87936 16.7294 9.12132 15.4234C9.48678 13.6094 10.4698 11.9781 11.903 10.8075C13.3362 9.63691 15.1308 8.99934 16.9813 9.00341C18.8517 9.00048 20.6651 9.64734 22.1113 10.8334C23.0108 11.577 23.7346 12.5105 24.2308 13.5669C24.727 14.6232 24.9833 15.7763 24.9813 16.9434C24.9691 18.0112 24.7383 19.0651 24.3032 20.0403C23.868 21.0154 23.2378 21.8911 22.4513 22.6134Z",
    fill: "#DFDFDF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8614 15.8034C22.6262 14.6503 22.0571 13.5919 21.225 12.7598C20.3929 11.9276 19.3344 11.3586 18.1814 11.1234C17.9161 11.0704 17.6407 11.1249 17.4157 11.2749C17.1906 11.4249 17.0344 11.6582 16.9814 11.9234C16.9283 12.1886 16.9828 12.464 17.1328 12.6891C17.2829 12.9141 17.5161 13.0704 17.7814 13.1234C18.5501 13.2802 19.2557 13.6596 19.8105 14.2143C20.3652 14.7691 20.7446 15.4747 20.9014 16.2434C20.9481 16.4727 21.0738 16.6783 21.2565 16.8245C21.4392 16.9707 21.6674 17.0481 21.9014 17.0434H22.1014C22.2346 17.0155 22.3608 16.9606 22.4721 16.8821C22.5834 16.8037 22.6775 16.7034 22.7487 16.5873C22.8199 16.4712 22.8666 16.3417 22.8859 16.207C22.9053 16.0722 22.8969 15.9348 22.8614 15.8034Z",
    fill: "#DFDFDF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    width: 2,
    height: 5,
    rx: 1,
    fill: "#DFDFDF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 17.5,
    width: 2,
    height: 5,
    rx: 1,
    transform: "rotate(-90 0 17.5)",
    fill: "#DFDFDF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 17.5,
    width: 2,
    height: 5,
    rx: 1,
    transform: "rotate(-90 29 17.5)",
    fill: "#DFDFDF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 28.5355,
    y: 3,
    width: 2,
    height: 5,
    rx: 1,
    transform: "rotate(45 28.5355 3)",
    fill: "#DFDFDF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4.41418,
    width: 2,
    height: 5,
    rx: 1,
    transform: "rotate(-45 3 4.41418)",
    fill: "#DFDFDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup15);
export default __webpack_public_path__ + "static/media/Group 15.3e9244a22eb081993b6e1e2fef444419.svg";
export { ForwardRef as ReactComponent };